<template>
  <div>
    <b-modal
      :title="title"
      size="md"
      centered
      hide-footer
      header-class="head-modal"
      content-class="preview-modal"
      v-model="modalShow"
    >
      <slot></slot>
    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'PreviewPrintHTMLFormat',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: '預覽'
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    },
  },
  data () {
    return {
      refsName: '',
      file: '',
      viewImg: ''
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  watch: {

  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="scss">
.preview-modal {
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Modal/PreviewPrintHTMLFormatModal.vue